import React from 'react'
import '../styles.scss'

const WarrantyPage = () => {
  window.scrollTo(0, 90)
  return (
    <div className="comming-soon">
      <h2>Warranty & Return Policy</h2>
      <h6>comming soon</h6>
    </div>
  )
}

export default WarrantyPage
